import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GradientCircularProgressContainer from '../../../components/common/GradientCircularProgressContainer';

const QboLaunch: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/');
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <p className="mt-4 text-xl">Launching Relentless Health...</p>
      <GradientCircularProgressContainer loadingMessage="Connecting to QuickBooks..." />
    </div>
  );
};

export default QboLaunch;
